import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import {
  Grid,
  Button,
  Paper,
  Box,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Modal,
} from "@mui/material";
import { FormProvider } from "../FormContext";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import LoadingOverlay from "../components/loadingOverlay/LoadingOverlay";
import DraggableElement from "./DraggableElement";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { formElements } from "../store/formSlice";
import {
  mergeElementsWithFormValues,
  fetchClientDetailData,
  processElement,
  processParaElementAttr,
} from "../utils/formUtils";
import {
  HHCONTRACTSTATUSENUMTYPE,
  ROLE,
  STATUS,
  USERROLE,
} from "../utils/commonConstant";
import { fetchHHContractById } from "../api/contractVersionService";
import Signature from "../components/FormElements/Signature/Signature";
import HorizotalContaier from "../components/FormElements/HorizontalContainer/HorizontalContainer";
import InfoIcon from "@mui/icons-material/Info";
import { HighlightContext } from "../context/HighlightContext";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";

const ClientFormFillPage = (props) => {
  const navigate = useNavigate();
  const { clientId, contractVersionId } = useParams();
  const [loading, setLoading] = useState(false);
  const [contractId, setContractId] = useState(null);
  const userId = localStorage.getItem("UserId");
  const formElementValues = useSelector(formElements);
  const [elements, setElements] = useState([]);
  const ToCaptureRef = useRef();
  const [commentDialogOpen, setCommentDialogOpen] = useState(false); // State for dialog
  const [comment, setComment] = useState(""); // State for comment
  const [actionType, setActionType] = useState(null);
  const [clientSignatureElement, setclientSignatureElement] = useState(null);
  const [noComment, setNoComment] = useState(false);
  const [formData, setFormData] = useState({
    clientName: "",
  });
  const [clientError, setClientError] = useState({
    clientName: false,
    errorMessage: "",
  });
  const { acceptReject, setAcceptReject } = useContext(HighlightContext);

  const validateRequiredFields = () => {
    let isValid = true;

    const updatedElements = elements.map((element) => {
      if (element.props.required && !element.props.value) {
        isValid = false;
        return {
          ...element,
          props: {
            ...element.props,
            error: true,
            helperText: "This field is required",
          },
        };
      }
      return {
        ...element,
        props: {
          ...element.props,
          error: false,
          helperText: "",
        },
      };
    });
    setElements(updatedElements);
    return isValid;
  };

  const getAllComments = (elements) => {
    const commentClass = document.querySelectorAll(".selection-highlight");
    const newComments = [];
    elements.forEach(element => {
      var tcComments = element.props.trackChangesComments;
      if (tcComments && Object.keys(tcComments).length !== 0) {
        Object.keys(tcComments).forEach(key => {
          let changes = tcComments[key];
          changes?.forEach(change => {
            if (change.userRole && (change.userRole == 'Client')) {
              newComments.push(change);
            }
          })
        });
      }
    });
    return commentClass.length + newComments.length ?? 0;
  };

  const handleSign = async (actionTypeWithComment) => {
    setLoading(true);
    elements.map((element) => {
      if (element.type === "signature") {
        element.props = { ...element.props, disabled: false };
      }
      if (element.type === "horizontalContainer" && element.items) {
        element.items = element.items.map((item) => {
          if (item.type === "signature") {
            item.props = { ...item.props, disabled: false };
          }
          return item;
        });
      }
      return element;
    });
    // const processParaAttrList = (list) =>
    //   list.map((element) => {
    //     return processParaElementAttr(element,ROLE.CLIENT,false,true);
    //   });
    // const processedParaElementsAttr = processParaAttrList(elements);
    try {
      const res = await fetchFromWebApi(
        `HHContract/ClientSignHHManagerDocument`,
        {
          method: "POST",
          body: JSON.stringify({
            id: contractId,
            userId: userId,
            metaData: elements,
            isApproved:
              actionTypeWithComment.actionType === STATUS.APPROVED
                ? true
                : false,
            comment: actionTypeWithComment.comment,
            clientName: actionTypeWithComment.clientName,
            NoOfComments: getAllComments(elements)
          }),
        }
      );
      setLoading(false);
      if (res?.ok) {
        if (actionTypeWithComment.actionType === STATUS.APPROVED) {
          toast.success("Contract signed successfully.");
          navigate("/thank-you");
        } else {
          navigate("/rejected");
        }
      } else {
        toast.error("Failed to sign contract:", await res.text());
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error while signing contract:", error);
    }
  };

  const [enterNameOpen, setEnterNameOpen] = React.useState(false);

  const handleEnterNameOpen = () => {
    setEnterNameOpen(true);
  };

  const handleEnterNameClose = () => {
    setEnterNameOpen(false);
  };

  const fieldMappings = {
    SubcontractorName: "SubcontractorName",
    FirstName: "FirstName",
    LastName: "LastName",
    Email: "Email",
    PersonalNo: "MobileNumber",
    Mobile: "MobileNumber",
    Address: "AddressLine1",
    City: "City",
    RecipientRole: "Subcontractor",
    Zipcode: "Postcode",
    ClientName: "ClientName",
    ClientAddress: "ClientAddress",
  };
  useEffect(() => {
    async function fetchData() {
      const formData = await fetchHHContractById(contractVersionId);
      const clientData = await fetchClientDetailData(clientId);
      console.log("Contract Data:", formData);
      console.log("Client Data:", clientData);

      if (clientData.ClientAddress) {
        clientData.ClientAddress = clientData.ClientAddress.replace(/\n/g, ", ");
      }
      //make signature disable for Subcontractor and  if COApproval is  Approved
      const disableSignature = (element, condition) => {
        if (element.type === "signature" && condition(element)) {
          return { ...element, props: { ...element.props, disabled: true } };
        }

        if (element.type === "horizontalContainer" && element.items) {
          element.items = element.items.map((item) =>
            disableSignature(item, condition)
          );
        }

        return element;
      };

      const shouldDisable = (element) => {
        if (formData.COApprovalStatus === HHCONTRACTSTATUSENUMTYPE.APPROVED) {
          return true;
        }
        return element.props.selectedField === "Subcontractor";
      };
      //processing mapped field with pulled data
      const updatedElements = formData.MetaData.map((element) =>
        disableSignature(element, shouldDisable)
      );
      const processList = (list) =>
        list.map((element) => {
          return processElement(element, clientData, fieldMappings);
        });
      const processedElements = processList(updatedElements);
      const processParaAttrList = (list) =>
        list.map((element) => {
          return processParaElementAttr(element, ROLE.CLIENT);
        });
      const processedParaElementsAttr = processParaAttrList(processedElements);
      setElements(processedParaElementsAttr);
      //setElements(processedElements);
      setContractId(formData.Id);
      // Your logic to use the data goes here.

    }
    handleEnterNameOpen()
    // try {
    //   if (localStorage?.getItem('Token')) {
        fetchData();
    //   } else {
    //     const currentUrl = encodeURIComponent(window.location.origin);
    //     const baseUrl = window.location.origin;
    //     const redirectUrl = `${baseUrl}/auth-callback?redirect=${currentUrl}/client-sign/${clientId}/${contractVersionId}`;
    //     window.location.href = `${process.env.REACT_APP_BASE_API_URL
    //       }/Auth/HHPortal?hhredirect=${encodeURIComponent(redirectUrl)}`;
    //   }
    // } catch (error) {
    //   // If any of the promises fail, this catch block will execute.
    //   console.error("Failed to fetch data:", error);
    //   const currentUrl = encodeURIComponent(window.location.origin);
    //   const baseUrl = window.location.origin;
    //   const redirectUrl = `${baseUrl}/auth-callback?redirect=${currentUrl}/client-sign/${clientId}/${contractVersionId}`;
    //   window.location.href = `${process.env.REACT_APP_BASE_API_URL
    //     }/Auth/HHPortal?hhredirect=${encodeURIComponent(redirectUrl)}`;
    // }
  }, [clientId]);

  const handelConfirmOpen = async (actionType) => {
    if (actionType === STATUS.APPROVED) {
      const trackChangeelements = document.querySelectorAll(
        ".track-changes"
      );

      for (const element of trackChangeelements) {
        if (element.dataset.status === "Created") {
          const spanElement = document.querySelector(`span[data-change-id="${element.dataset.changeId}"]`);
          if (spanElement) {
            spanElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          let errorMessage = element.dataset.actionType.toLowerCase() === 'rejected' ? 'Form cannot be approved due to rejected comments.' : 'Please resolve all track changes before proceeding.'
          toast.error(errorMessage);
          return;
        }
      }
    }
    mergeElementsWithFormValues(elements, formElementValues);
    const isValid = validateRequiredFields();
    const clientSignature = elements.find(
      (element) =>
        element.type === "signature" &&
        element.props.selectedField === "Client" &&
        !element.props.value
    );
    const clientSignatureHorizontalContainer = elements.find(
      (element) =>
        element.type === "horizontalContainer" &&
        element.items &&
        element.items.some(
          (item) =>
            item.type === "signature" &&
            item.props.selectedField === "Client" &&
            !item.props.value
        )
    );
    console.log(
      clientSignatureHorizontalContainer,
      "clientSignatureHorizontalContainer"
    );
    if (clientSignatureHorizontalContainer) {
      const updatedSignature = {
        ...clientSignatureHorizontalContainer,
      };
      setclientSignatureElement(updatedSignature);
    }
    if (clientSignature) {
      const updatedSignature = {
        ...clientSignature,
        props: {
          ...clientSignature.props,
          width: "-webkit-fill-available",
        },
      };
      setclientSignatureElement(updatedSignature);
    }
    if (!isValid) {
      const firstInvalidElement = elements.find(
        (element) => element.props.required && !element.props.value
      );
      const elementNode = document.getElementById(firstInvalidElement.id);
      if (elementNode) {
        elementNode.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }
    setActionType(actionType);
    setCommentDialogOpen(true);
  };
  const handleCommentDialogClose = () => {
    setCommentDialogOpen(false); // Close the dialog
    setclientSignatureElement(null);
  };
  const handleCommentChange = (event) => {
    setComment(event.target.value); // Update comment state
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "clientName" && value) {
      setClientError({ clientName: false, errorMessage: "" });
    }
  };

  const handleEnterNameChange = (e) => {
    const { name, value } = e.target;
    formData.clientName = value;
    localStorage.setItem('Name', value);
  };

  const handleOpenTour = () => {
    navigate(`/tutorial`);
  }

  const handleCommentSubmit = () => {
    mergeElementsWithFormValues(elements, formElementValues);
    console.log("Comment:", comment);
    if (!comment.trim() && !noComment) {
      toast.error("Comment is required.");
      return;
    }
    if (actionType === STATUS.REJECTED && !comment.trim()) {
      toast.error("Comment is mandatory if the document is rejected.");
      return;
    }
    if (!formData.clientName) {
      setClientError({
        clientName: true,
        errorMessage: "Client Name is required",
      });
      return;
    }
    handleSign({
      actionType: actionType,
      comment: comment,
      clientName: formData.clientName,
    });
    setCommentDialogOpen(false);
  };
  const updateElementProps = useCallback(
    (id, newProps) => {
      const updateProps = (elements) => {
        return elements
          .map((element) => {
            if (element.id === id) {
              if (newProps.remove === true) {
                return null; // Mark element for removal
              }
              return { ...element, props: { ...element.props, ...newProps } };
            }
            if (element.items) {
              const updatedItems = updateProps(element.items).filter(
                (item) => item !== null
              );
              return { ...element, items: updatedItems };
            }
            return element;
          })
          .filter((element) => element !== null); // Remove marked elements
      };
      setElements((prevElements) => updateProps(prevElements));

    },
    [setElements]
  );

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "25%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    maxHeight: "90vh",
  };

  return (
    <FormProvider>
      <Box position="relative" minHeight="100vh">
        <Grid
          container
          justifyContent="center"
          ref={ToCaptureRef}
          sx={{
            backgroundColor: "#CCCCCC",
          }}
        >
          <Grid item xs={12} md={8}>
            <DndContext autoScroll={false} collisionDetection={closestCenter}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{ padding: 2, minHeight: "700px" }}
                    >
                      <Grid container spacing={2}>
                        <SortableContext
                          items={elements}
                          strategy={verticalListSortingStrategy}
                        >
                          {elements.map((element, index) => {
                            return (
                              <Grid
                                xs={12}
                                item
                                key={element.id}
                                sx={{
                                  ...(element.type === "signature" ||
                                    element.type === "fileUpload"
                                    ? { pageBreakInside: "avoid" }
                                    : {}),
                                  ...(element.type === "logo" && {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }),
                                }}
                              >
                                <DraggableElement id={element.id} index={index}>
                                  <FormElement
                                    element={element}
                                    onPropsChange={(newProps, forceSave = true) =>
                                      updateElementProps(element.id, newProps)
                                    }
                                    dragHandle={false}
                                    isShowTrackHistory={true}
                                    trackChangeDisplayBy={USERROLE.CLIENT}
                                    formPreview={true}
                                  />
                                </DraggableElement>
                              </Grid>
                            );
                          })}
                        </SortableContext>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </DndContext>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "20px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <Box sx={{ marginTop: 2 }}>
              <Button
                variant="contained"
                color="success"
                disabled={acceptReject.accept}
                sx={{
                  fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                  padding: {
                    xs: "10px 16px",
                    sm: "12px 18px",
                    md: "14px 20px",
                  },
                  marginRight: 2,
                }}
                onClick={() => handelConfirmOpen(STATUS.APPROVED)}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                disabled={acceptReject.reject}
                sx={{
                  fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                  padding: {
                    xs: "10px 16px",
                    sm: "12px 18px",
                    md: "14px 20px",
                  },
                }}
                onClick={() => handelConfirmOpen(STATUS.REJECTED)}
              >
                Reject
              </Button>
            </Box>
          </Grid>
        </Grid>
        <LoadingOverlay open={loading} />
      </Box>
      <Dialog
        open={commentDialogOpen}
        onClose={handleCommentDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {actionType === STATUS.APPROVED && (
            <Tooltip
              title="By approving this contract, you confirm its' contents reflect the true working relationship you have with your subcontractors"
              arrow
            >
              <InfoIcon sx={{ marginRight: 1, color: "primary.main" }} />
            </Tooltip>
          )}
          Write a Comment
        </DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={noComment}
                onChange={(e) => setNoComment(e.target.checked)}
                color="primary"
              />
            }
            label="No Comment Required"
          />
          <TextField
            autoFocus
            margin="dense"
            id="comment"
            label="Comment"
            type="text"
            fullWidth
            multiline
            rows={5}
            value={comment}
            onChange={handleCommentChange}
            placeholder="Write your comment here"
          />
          {clientSignatureElement && (
            <>
              <Typography variant="subtitle1" gutterBottom>
                Please Open Signature to Sign !!!
              </Typography>
              {clientSignatureElement?.type === "signature" && (
                <Signature
                  {...clientSignatureElement.props}
                  elementId={clientSignatureElement.id}
                  border={false}
                />
              )}
              {clientSignatureElement?.type === "horizontalContainer" && (
                <HorizotalContaier
                  items={clientSignatureElement.items}
                  dragHandle={false}
                  setSelectedElementId={clientSignatureElement.id}
                  width={clientSignatureElement.props.width}
                />
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCommentDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCommentSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        aria-labelledby="form-preview-title"
        aria-describedby="form-preview-description"
        // sx={{ backgroundColor: "#CCCCCC" }}
        disableEnforceFocus
        disableAutoFocus
        open={enterNameOpen} onClose={handleEnterNameClose} >
        <Box
          id="modal-box"
          sx={{
            ...modalStyle,
            position: "relative",
            overflowY: "auto",
            backgroundColor: "#CCCCCC",
            width: {
              xs: '50%',
              sm: '50%',
              md: '30%',
              lg: '25%'
            },
          }}
        >
          <Button
            variant="contained"
            color="success"
            sx={{
              justifySelf: 'end',
            }}
            onClick={() => handleOpenTour()}
          >
            Watch Tutorial
          </Button>
          <h2>Enter Your Name</h2>
          <TextField
            autoFocus
            margin="dense"
            id="cName"
            name="cName"
            label="Before we begin - what's your name?"
            type="text"
            fullWidth
            value={formData.cName}
            onChange={handleEnterNameChange}
            error={clientError.cName}
            helperText={clientError.cName ? clientError.errorMessage : ""}
          />
          <Box>
            <Button onClick={handleEnterNameClose}>Ok</Button>
          </Box>
        </Box>
      </Modal>
    </FormProvider>
  );
};

export default ClientFormFillPage;